/**
 * Stripe publishable key — dev.sentrykit.com always uses the test key from config/dev.env.js.
 */

export var STRIPE_PUBLISHABLE_KEY_DEV = 'pk_test_FsvViTDQA6DQaHXMFpvvd0uH'

export function isDevSentrykitHost () {
  if (typeof window === 'undefined' || !window.location) return false
  var host = String(window.location.hostname || '').toLowerCase()
  return host === 'dev.sentrykit.com'
}

export function stripePublishableKey () {
  if (isDevSentrykitHost()) {
    return STRIPE_PUBLISHABLE_KEY_DEV
  }
  return process.env.STRIPE_PUBLISHABLE_KEY || ''
}



// WEBPACK FOOTER //
// ./src/utils/stripePublishableKey.js